import type {SkipToken} from '@reduxjs/toolkit/query'
import {skipToken} from '@reduxjs/toolkit/query'

import {useAppSelector} from '../../../hooks/react-redux'
import {useQueryParam} from '../../../hooks/routes'
import {getBuild, getExtensionEndpoint} from '../../../selectors'
import type {GetBuildLogTimelineArg} from '../../../services/rest'
import type {BuildId} from '../../../types'

import type {LogView} from './BuildLog.types'

export function useTimelineArg(buildId: BuildId): GetBuildLogTimelineArg | SkipToken {
  const endpoint = useAppSelector(
    state => getExtensionEndpoint(state, 'fetchBuildLogTimeline')?.endpoint,
  )
  const isStarted = useAppSelector(state => {
    const build = getBuild(state, buildId)
    return build?.state != null && build.state !== 'queued'
  })
  const logView = useQueryParam('logView') as LogView | undefined

  return endpoint != null && isStarted ? {endpoint, buildId, logView} : skipToken
}
